const { IS_PRODUCTION, IS_DEV } = process.env

const oneSignalData = {
  dev: {
    appId: 'd7db7817-97bc-4c23-825f-f19e406c82d1',
    subdomainName: 'guidehero-dev',
    httpPermissionRequest: {
      enable: true
    }
  },
  stage: {
    appId: 'fd60746a-1d0b-4372-9ed0-624bd6b0e70c',
    subdomainName: 'guidehero-stag',
    httpPermissionRequest: {
      enable: true
    }
  },
  prod: {
    appId: 'b4169138-bd62-4044-bb6d-eb7b463ddee3',
    httpPermissionRequest: {
      enable: false
    }
  }
}

const apiVersion = 'v1'
const requestTimeout = 8000
const oneSignalOptions = IS_PRODUCTION ? oneSignalData.prod : IS_DEV ? oneSignalData.dev : oneSignalData.stage
const appId = IS_PRODUCTION ? '172744999822880' : IS_DEV ? '685629501639031' : '268170017022479'
const apiPath = IS_PRODUCTION
  ? 'https://api.guidehero.co/api'
  : IS_DEV
  ? 'https://dev.guidehero.co/api'
  : 'https://staging.guidehero.co/api'

export default {
  apiPath,
  apiVersion,
  requestTimeout,
  appId,
  oneSignalOptions,
  isProd: IS_PRODUCTION
}
